import { useContext, useMemo } from 'react';
import type { Chat } from '@trinity/chat';
import { ActiveChatSessionContext } from '@trinity/chat-components/components/Chat';
import { useHover } from '@trinity/chat-components/hooks/useHover';
import { ChatHistoryItemContext } from './context';
import { ChatHistoryItem } from './Item';
import { ItemPlaceholder } from './Item.Placeholder';

type Props = {
  className?: string;
  item: Chat.Instance;
  isMenuOpen?: boolean;
  onMenuOpen?: () => void;
  onMenuClose?: () => void;
};

export const ChatHistoryItemContainer = ({ className, item, isMenuOpen = false, onMenuOpen, onMenuClose }: Props) => {
  const chat = useContext(ActiveChatSessionContext);

  const isActive = useMemo(() => chat.identifier === item.identifier, [chat.identifier, item.identifier]);

  const [ref, isHovering] = useHover();

  const isPlaceholder = item.id == null;

  if (isPlaceholder) {
    return <ItemPlaceholder className={className} />;
  }

  const ctx = {
    isActive,
    item,
  };

  return (
    <ChatHistoryItemContext.Provider value={ctx}>
      <ChatHistoryItem
        className={className}
        ref={ref}
        isActive={isActive}
        isHovering={isHovering}
        isMenuOpen={isMenuOpen}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
      />
    </ChatHistoryItemContext.Provider>
  );
};
